import { PropsWithTheme, WHITE_100 } from '@rategravity/own-up-component-library';
import React from 'react';
import styled from 'styled-components';
import { useABComparison } from '../data/dataProvider';
import { MonthlyPayment } from '../types';
import { MortgageLineChart } from './SummaryChart';
import { SummaryPlate } from './SummaryPlate';

const Container = styled.div<{ marginTop?: string }>`
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  row-gap: ${({ theme }: PropsWithTheme<{}>) => theme.spacing(4)}px;
  column-gap: ${({ theme }: PropsWithTheme<{}>) => theme.spacing(9)}px;
  ${({ theme }: PropsWithTheme<{}>) => theme.breakpoints.up('md')} {
    padding: ${({ theme }: PropsWithTheme<{}>) => theme.spacing(3)}px;
    flex-direction: row;
  }
  background-color: ${WHITE_100};
  margin-top: ${({ theme, marginTop }: PropsWithTheme<{ marginTop?: string }>) =>
    marginTop ? marginTop : theme.spacing(5)}px;
`;

export const CalculationSummary = () => {
  const {
    state: { showFull },
    getPayments
  } = useABComparison();
  let A: MonthlyPayment[] = [];
  let B: MonthlyPayment[] = [];
  const payments = getPayments();
  if (payments) {
    A = payments.A;
    B = payments.B;
  }
  return (
    <>
      {showFull && (
        <>
          {payments !== null && (
            <Container>
              <MortgageLineChart dataSet1={A} dataSet2={B} />
            </Container>
          )}
          <Container marginTop="0">
            <SummaryPlate variant="A" />
            <SummaryPlate variant="B" />
          </Container>
        </>
      )}
    </>
  );
};
